//import testFile0 from "../sample/00-frame-and-line.cg3"
//import testPic0  from "../sample/00-frame-and-line.png"
import testFile00 from "../../sample/00-variae.cg3";
import  testPic00 from "../../sample/00-variae.png";
import testFile01 from "../../sample/01-point-on-segment.cg3";
import  testPic01 from "../../sample/01-point-on-segment.png";
import testFile02 from "../../sample/02-planes.cg3";
import  testPic02 from "../../sample/02-planes.png";
import testFile03 from "../../sample/03-segment-on-plane.cg3";
import  testPic03 from "../../sample/03-segment-on-plane.png";
import testFile04 from "../../sample/04-triangle.cg3";
import  testPic04 from "../../sample/04-triangle.png";
import testFile05 from "../../sample/05-point-on-triangle.cg3";
import  testPic05 from "../../sample/05-point-on-triangle.png";
import testFile06 from "../../sample/06-triangle-and-normal.cg3";
import  testPic06 from "../../sample/06-triangle-and-normal.png";
import testFile07 from "../../sample/07-sphere-and-segments.cg3";
import  testPic07 from "../../sample/07-sphere-and-segments.png";
import testFile08 from "../../sample/08-frame-and-line.cg3";
import  testPic08 from "../../sample/08-frame-and-line.png";
import testFile09 from "../../sample/09-conics.cg3";
import  testPic09 from "../../sample/09-conics.png";
import testFile10 from "../../sample/10-cubes.cg3";
import  testPic10 from "../../sample/10-cubes.png";
import testFile11 from "../../sample/11-cylinder.cg3";
import  testPic11 from "../../sample/11-cylinder.png";
import testFile12 from "../../sample/12-half-line-and-vector.cg3";
import  testPic12 from "../../sample/12-half-line-and-vector.png";
import testFile13 from "../../sample/13-half-plane-and-polygon.cg3";
import  testPic13 from "../../sample/13-half-plane-and-polygon.png";
import testFile14 from "../../sample/14-midpoint.cg3";
import  testPic14 from "../../sample/14-midpoint.png";
import testFile15 from "../../sample/15-parallel.cg3";
import  testPic15 from "../../sample/15-parallel.png";
import testFile16 from "../../sample/16-rotation.cg3";
import  testPic16 from "../../sample/16-rotation.png";
import testFile17 from "../../sample/17-symmetry.cg3";
import  testPic17 from "../../sample/17-symmetry.png";
import testFile18 from "../../sample/18-translation.cg3";
import  testPic18 from "../../sample/18-translation.png";
import testFile19 from "../../sample/19-cube-cut.cg3";
import  testPic19 from "../../sample/19-cube-cut.cg3";


import {tracker} from "./analytics";

async function testIt () {
    gatherResources();
    readLocationParam();
    tracker().trackEvent("files", "load-sample", [chosenFile], []);
    console.log(`Loading CG3 file ${chosenFile}.`);
    let p = new Parser(chosenFile);
    if (window.cabri) window.cabri.document = await p.parse();
    window.cabri.objects = p.objects;
    console.log(`Promise to load CG3 file ${chosenFile}.`,
        window.cabri.document);

    createComponents();
}

let popupDiv = null;
let testFiles, testPics, testFileNames = [];
let chosenFile = null, chosenPic, chosenFileName;

function gatherResources () {
    // JML would be ssmartter to create arrays dynnamically acccording to the
    // content of sample (PL: yes, need to shop for the appropriate webpack
    // plugin)
    testFiles =
        [testFile00, testFile01, testFile02, testFile03, testFile04, testFile05,
         testFile06, testFile07, testFile08, testFile09, testFile10, testFile11,
         testFile12, testFile13, testFile14, testFile15, testFile16, testFile17,
         testFile18, testFile19];
    testPics =
        [testPic00, testPic01, testPic02, testPic03, testPic04, testPic05, testPic06,
         testPic07, testPic08, testPic09, testPic10, testPic11, testPic12, testPic13,
         testPic14, testPic15, testPic16, testPic17, testPic18, testPic19];
    testFiles.forEach(tf => {
        testFileNames.push(tf.replace(/.*\/([0-9a-z\-]*).(cg3|xml)/, "$1"));
    });
}

function readLocationParam () {
    let l = window.location.href;
    l = l.replace(/.*sample=([0-9a-z\-]+)(&.)*/, "$1");
    let i = 0;
    testFileNames.forEach(f => {
        if (i === 0 || f === l) {
            chosenFileName = f;
            chosenFile = testFiles[i];
            chosenPic = testPics[i];
        }
        i++;
    });

    window.document.title = `Cabri3D - Sample - ${chosenFileName}`;

    window.testFiles = testFiles;
    window.testPics = testPics;
    window.testFileNames = testFileNames;
    window.chosenFile = chosenFile;
    window.chosenFileName = chosenFileName;
    window.chosenPic = chosenPic;

}

function createComponents () {
// display a popup with the choice of sample
    popupDiv = document.createElement("div");
    popupDiv.setAttribute("style",
        "z-index:10; position:absolute; top:1em; right:1em; width:15em; height:2em; color:white;");
    let s = "<select id='sampleChoice'>";
    testFileNames.forEach(n => {
        let selected = n === chosenFileName;
        s += `<option ${selected ? "selected=" : ""} value='${n}'>${n}</option>`;
    });
    s += "</select>&nbsp;<button onclick='window.openPic()'>image</button>";
    popupDiv.innerHTML = s;
    document.body.appendChild(popupDiv);
    let sampleChoice = document.getElementById("sampleChoice");
    sampleChoice.addEventListener("change", (evt) => {
        console.log(window.sampleChoice.value);
        let l = window.location.href;
        if (/.*sample=([0-9a-z\-]+)(&.)*/.test(l)) {
            l = l.replace(/sample=([0-9a-z\-]+)(&.)*/,
                `sample=${sampleChoice.value}`);
        }
        else {
            l = l + (l.indexOf("?") > -1 ? "&" : "?") +
                `sample=${sampleChoice.value}`;
        }
        window.location.href = l;
    });
    window.openPic = openPic;
}

function openPic () {
    window.open(chosenPic, "samplePictures");
}

function disable () {
    if (popupDiv) document.body.removeChild(popupDiv);
    popupDiv = null;
}

const SampleDemo = {testIt: testIt, disable: disable};

export default SampleDemo;